export default __webpack_public_path__ + "static/media/fullscreen.bc64d6e6.svg";